import { ERROR_NEW_PASSWORD, ERROR_DISSONANCE, ERROR_NOT_CONDITION } from "@/const/values";

const regPassword = /^[0-9a-zA-Z]+$/

/**
 * �p�X���[�h�̈Í���
 * @param password - �p�X���[�h
 * @param publicKey - ���J��
 * @return �Í����p�X���[�h
 */
export const encryptPassword = async (password: string, publicKey: string): Promise<string> => {
    // ���J����base64����Buffer�֕ϊ�
    const publicKeyBinary = base64ToArrayBuffer(publicKey);

    // ���J���̃C���|�[�g
    const cryptoKey = await crypto.subtle.importKey(
        "spki", // key�t�H�[�}�b�g:spki(���J��)
        publicKeyBinary, // ���J����buffer
        {
            name: 'RSA-OAEP',
            hash: { name: "SHA-256" },
        },
        false,
        ["encrypt"]
    );

    const enc = new TextEncoder();
    const encodedMessage = enc.encode(password);

    // �p�X���[�h�̈Í���
    const encryptedData = await window.crypto.subtle.encrypt(
        {
            name: "RSA-OAEP"
        },
        cryptoKey,
        encodedMessage
    );

    // base64�ϊ����ĕԂ�
    return arrayBufferToBase64(encryptedData);
}

/**
 * base64�������ArrayBuffer�֕ϊ�
 * @param base64str - base64������
 * @return ArrayBuffer
 */
const base64ToArrayBuffer = (base64str: string): ArrayBufferLike => {
    // Base64���f�R�[�h
    const binary_string = window.atob(base64str);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);

    // ArrayBuffer�֕ϊ�
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }

    return bytes.buffer;
}

/**
 * ArrayBuffer��base64������֕ϊ�
 * @param base64str - base64������
 * @return ArrayBuffer
 */
const arrayBufferToBase64 = (buffer: ArrayBufferLike): string => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    // ������֕ϊ�
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    // base64�`���֕ϊ�
    return window.btoa(binary);
}
/**
 * �p�X���[�h�`�F�b�N
 * @param e - ���K�\���p�^�[��
 * @target target - ���̓p�X���[�h
 * @return ����
 */
const updatedataValidation = (e: RegExp, target: string): Boolean => {
    if (!target.match(/[a-zA-Z]/)) {
        return false;
    }
    if (!target.match(/[0-9]/)) {
        return false;
    }
    return e.test(target);
}
/**
 * �p�X���[�h�̃`�F�b�N���s�����b�Z�[�W��Ԃ�
 * @param passwordinfo - ���̓p�X���[�h
 * @return �G���[���b�Z�[�W
 */
export const checkPassword = (passwordinfo: PasswordType.InputPasswordInfo): string => {
    if (passwordinfo.password === '' || passwordinfo.password === undefined) {
        return ERROR_NEW_PASSWORD;
    } else if (passwordinfo.password !== passwordinfo.confirmPassword) {
        return ERROR_DISSONANCE;
    } else if (!updatedataValidation(regPassword, passwordinfo.password)) {
        return ERROR_NOT_CONDITION;
    }
    return '';
}
